const local = {
	production: false,
	userPoolId: "us-west-2_ARR238dcG",
	clientId: "5vttb4nuqei73f2nhk89a1dhlf",
	region: "us-west-2",
	identityPoolId: "us-west-2:5798f46a-4304-40ef-a2a5-5dc587b76008",
	oAuthConfig: {
		domain: "dev-fsot-ai-hub.auth.us-west-2.amazoncognito.com",
		redirectSignIn: `http://${window.location.host}`,
		redirectSignOut: `http://${window.location.host}`,
		responseType: "code",
		identityProvider: "MSAzureAD",
		// scopes: ['email', 'openid', 'aws.cognito.signin.user.admin'],
	},
	envBasePath: "/local",
	baseUrl: "http://localhost:3000/dev/adminPanel",
	biaUserRole1Arn: "arn:aws:iam::494570837593:role/bia_user_role_1",
	biaAdminRole2Arn: "arn:aws:iam::494570837593:role/bia_admin_role_2",
	biaUserRole2Arn: "arn:aws:iam::494570837593:role/bia_user_role_2",
	biaAdminRole3Arn: "arn:aws:iam::494570837593:role/bia_admin_role_3",
};

const dev = {
	production: false,
	userPoolId: "us-west-2_ARR238dcG",
	clientId: "5vttb4nuqei73f2nhk89a1dhlf",
	region: "us-west-2",
	identityPoolId: "us-west-2:5798f46a-4304-40ef-a2a5-5dc587b76008",
	oAuthConfig: {
		domain: "dev-fsot-ai-hub.auth.us-west-2.amazoncognito.com",
		redirectSignIn: `https://${window.location.host}`,
		redirectSignOut: `https://${window.location.host}`,
		responseType: "code",
		identityProvider: "MSAzureAD",
		// scopes: ['email', 'openid', 'aws.cognito.signin.user.admin'],
	},
	envBasePath: "/dev",
	baseUrl: "https://muzt3zyiy3.execute-api.us-west-2.amazonaws.com/dev/adminPanel",
	biaUserRole1Arn: "arn:aws:iam::494570837593:role/bia_user_role_1",
	biaAdminRole2Arn: "arn:aws:iam::494570837593:role/bia_admin_role_2",
	biaUserRole2Arn: "arn:aws:iam::494570837593:role/bia_user_role_2",
	biaAdminRole3Arn: "arn:aws:iam::494570837593:role/bia_admin_role_3",
};

const prod = {
	production: true,
	userPoolId: "us-west-2_MczNswh0S",
	clientId: "5lq1q5g22r1epniu9htpmh3et",
	region: "us-west-2",
	identityPoolId: "us-west-2:c7325f9f-4f88-4c2f-b41f-c4869fae45b0",
	oAuthConfig: {
		domain: "fsot-ai-hub.auth.us-west-2.amazoncognito.com",
		redirectSignIn: `https://${window.location.host}`,
		redirectSignOut: `https://${window.location.host}`,
		responseType: "code",
		identityProvider: "MSAzureAD",
		// scopes: ['email', 'openid', 'aws.cognito.signin.user.admin'],
	},
	envBasePath: "/prod",
	baseUrl: "https://abw5y3z7h6.execute-api.us-west-2.amazonaws.com/prod/adminPanel",
	biaAdminRole1Arn: "arn:aws:iam::977292734568:role/bia_admin_role_1",
	biaUserRole1Arn: "arn:aws:iam::977292734568:role/bia_user_role_1",
	biaAdminRole2Arn: "arn:aws:iam::977292734568:role/bia_admin_role_2",
	biaUserRole2Arn: "arn:aws:iam::977292734568:role/bia_user_role_2",
	biaAdminRole3Arn: "arn:aws:iam::977292734568:role/bia_admin_role_3",
};

export const environment =
	process.env.REACT_APP_STAGE === "local"
		? local
		: process.env.REACT_APP_STAGE === "dev"
		? dev
		: prod;
